/**
 * Общ layout за правните страници (Общи условия, Поверителност, Бисквитки, DPA).
 * Държи заглавие, дата/версия, навигация между страниците и футър на едно място.
 */
import React from 'react';
import { Link } from 'react-router-dom';
import './LegalPages.css';
import { LAST_UPDATED, VERSION, COMPANY } from './company';
import { useForceLightTheme } from '../../contexts/ThemeContext';

const NAV = [
  { to: '/privacy-policy', label: 'Поверителност' },
  { to: '/terms-of-service', label: 'Общи условия' },
  { to: '/dpa', label: 'DPA' },
];

// И1: правните страници са публични и LegalPages.css е изцяло светъл документ
// (бял лист, сиви заглавия). Тук темата не се обръща — тези страници се четат
// веднъж и са част от публичното лице на услугата.
export const LegalLayout = ({ title, active, children, updated }) => {
  useForceLightTheme();

  return (
  <div className="legal-page">
    <Link to="/" className="back-link">← Назад към приложението</Link>

    <div className="legal-page-header">
      <h1>{title}</h1>
      <p className="last-updated">Последна актуализация: {updated || LAST_UPDATED}</p>
      <p className="version">Версия: {VERSION}</p>
    </div>

    <nav className="legal-nav">
      {NAV.map((n) => (
        <Link key={n.to} to={n.to} className={active === n.to ? 'active' : undefined}>
          {n.label}
        </Link>
      ))}
    </nav>

    <div className="legal-content">{children}</div>

    <div className="legal-footer">
      <p>© {new Date().getFullYear()} {COMPANY.name}. Всички права запазени.</p>
      <p>
        <Link to="/privacy-policy">Поверителност</Link> |{' '}
        <Link to="/terms-of-service">Условия</Link> |{' '}
        <Link to="/dpa">DPA</Link>
      </p>
    </div>
  </div>
  );
};
